<template>
<div>
    <h1>{{ $t("chooseOrganizationView.title") }}</h1>
    <ul>
        <li :class="`list-item ${userOrganizationEventCount(organization) > 0 ? 'clickable' : 'disabled'}`"
            v-for="organization in store.currentUser.organizations"
            :key="organization.organizationId"
            @click="chooseOrganization(organization)"
        >
            <h3>{{ organization.name }}</h3>
            <p v-if="userOrganizationEventCount(organization) > 0">{{ $t("chooseOrganizationView.noEvents") }}</p>
        </li>
    </ul>
</div>
</template>

<script lang="ts">
import { store, Organization, User } from "store";
import axios from "axios";
import { defineComponent } from "vue";

export default defineComponent({
    mounted() {
        this.setTitle();
    },
    data() {
        return {
            store: store
        };
    },
    methods: {
        setTitle() {
            store.page.title = this.$t("chooseOrganizationView.title") as string;
            store.page.showTopNav = true;
        },
        userOrganizationEventCount(organization: Organization) {
            let events = store.events.filter(e => e.organizationId == organization.organizationId);
            return events.length;
        },
        async chooseOrganization(organization: Organization) {
            if (this.userOrganizationEventCount(organization) === 0) {
                return;
            }

            store.currentUser.selectedOrganizationId = organization.organizationId;
            // select first event of the organization that comes along when
            // selecting a new organization

            let event = store.events.find(e => e.organizationId == organization.organizationId);
            if (event) {
                store.currentUser.selectedEventId = event.eventId;
            } else {
                store.currentUser.selectedEventId = null;
            }

            await axios.put<User>(`users/${store.currentUser.userId}`, store.currentUser);

            store.selectedOrganization = organization;
            this.$router.push("/");
        }
    }
})

</script>